import _1 from './s2tpics/1.jpg'
import _3 from './s2tpics/3.jpg'
import _4 from './s2tpics/4.jpg'
import _5 from './s2tpics/5.jpg'
import _6 from './s2tpics/6.jpg'
export const imgref=[
    {
        url: _1,
        
    },
    {
        url: _3,
        
    },
    {
        url: _4,
    },
    {
        url:_5,
    },
    {
        url: _6,
    
    }
]